// extracted by mini-css-extract-plugin
export default {"folder":"nav_folders_content-module__folder--2eUUN"};